import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./createProvider.css";
import "./CreateInstallers.responsive.css";
import SideMenu from "../../features/sideMenu/SideMenu";
import CustomButton from "../../ui/button/Button";
import CustomSelect from "../../ui/select/Select";
import { fieldsAddInstallers } from "../../constants/addUser.constats";
import { itemsProviders } from "../../constants/providers";
import { createInstallerContact } from "../functions/Functions";
import useConfirmDialog from "../../features/modal/ConfirmDialog";

const CreateInstallers = ({ perfilInstaladorer, companies, API_URL }) => {
  const initialPayload = {
    nombre: null,
    apellidos: null,
    email: null,
    telefono: null,
    comentarios: null,
    latitud: null,
    longitud: null,
    md5Ine: null,
    md5Credencial: null,
    md5Foto: null,
    md5Imss: null,
    md5dc3: null,
    md5CertificadoMedico: null,
    md5Otro: null,
    progresoMultimedia: null,
    extensionIne: null,
    extensionCredencial: null,
    extensionDc3: null,
    extensionOtro: null,
    extensionFoto: null,
    extensionCertificado: null,
    extensionImss: null,
    numGafete: null,
    porDefecto: null,
    esProject: null,
    estatusConexion: null,
    fecha: null,
    usuarioTrello: null,
    ultimoGradoEstudios: null,
    certificadoDc3: null,
    tokenFCM: null,
    empresa: null,
    perfilInstalador: null,
    empresaId: null,
    habilitado: null,
    fechaVencimientoIne: null,
    fechaVencimientoImss: null,
    fechaVencimientoCertificadoMedico: null,
    fechaVencimientoDc3: null,
    rfc: null,
    vigDc3: null,
    vigIne: null,
    vigImss: null,
    vigCM: null,
  };
  const [payload, setPayload] = useState({ ...initialPayload });
  const { empresaId } = useParams();
  const showDialog = useConfirmDialog();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const empresaSeleccionada = companies.find(
      (empresa) => empresa.id === parseInt(empresaId)
    );
    const payloadFinal = {
      ...payload,
      empresa: empresaSeleccionada,
      perfilInstalador:
        perfilInstaladorer.find((p) => p.id === payload.perfilInstalador) ||
        null,
      porDefecto: false,
      esProject: false,
    };

    try {
      await createInstallerContact(API_URL, payloadFinal);
      showDialog({
        html: "Contacto creado con éxito.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
        onConfirm: () => navigate(`/proveedores/instaladores/${empresaId}`),
      });
    } catch (error) {
      showDialog({
        html: `Error al crear contacto:<br>${
          error.response?.data?.message || error.message
        }`,
        icon: "error",
        mostrarCancelar: false,
        confirmButtonText: "Aceptar",
      });
    }
  };

  const addInstaller = () => (
    <div className="form-container">
      <form>
        <h1>Agregar Instalador</h1>
        {fieldsAddInstallers.map((field) => (
          <div className="form-row" key={field.name}>
            <label className="form-label">
              {field.name === "lenguaje" ? "Idioma" : field.label}:
            </label>

            {field.name === "perfilInstalador" ? (
              // ⬇️ wrapper para poder forzar 100% en móvil vía CSS
              <div className="ci-select-wrap">
                <CustomSelect
                  options={perfilInstaladorer.map((perfil) => ({
                    value: perfil.id,
                    name: perfil.nombre,
                    icon: perfil.icon,
                  }))}
                  value={payload[field.name] || ""}
                  name={field.name}
                  onChange={handleChange}
                  width={window.innerWidth <= 480 ? "100%" : "500px"} // escritorio igual
                  height={"39px"}
                  textAlign={"left"}
                  color={"#6c757d"}
                  fontSize={"14px"}
                  fontWeight={600}
                  heightOption={"110px"}
                  topOption={"-40px"}
                  paddingTop={"8px"}
                  marginBottom={"6px"}
                />
              </div>
            ) : (
              <input
                className="form-input"
                type="text"
                name={field.name}
                value={payload[field.name] || ""}
                onChange={handleChange}
                placeholder={`Ingresa ${
                  field.label.toLowerCase() === "rfc"
                    ? "RFC"
                    : field.label.toLowerCase()
                }`}
              />
            )}
          </div>
        ))}

        <div className="button-container">
          <CustomButton
            text={"Guardar"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#62C776"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"75px"}
            height={"28px"}
            type={"button"}
            onClick={handleSubmit}
          />
        </div>
      </form>
    </div>
  );

  return (
    <div className="ci-layout" style={{ display: "flex", height: "100%" }}>
      <div className="ci-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>

      <div className="ci-main createUser">{addInstaller()}</div>
    </div>
  );
};

export default CreateInstallers;
